import { render, staticRenderFns } from "./TypeInit.vue?vue&type=template&id=f16dcd98&scoped=true"
import script from "./TypeInit.vue?vue&type=script&lang=js"
export * from "./TypeInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16dcd98",
  null
  
)

export default component.exports